export class LsSchemas {
	static readonly IndexSchema = {
		DayOfEvent: 'timestamp',
		LastIndexValue: 'aggregatedlast',
		YesterdayPrice: 'prev-aggregatedlast',
		PercentVariation: 'variationpreviousday'
	};

	static readonly TextMessageSchema = {
		timestamp: 'timestamp',
		meta: 'meta'
	};
	static readonly GroupStateChangeSchema = {
		group: 'group',
		timestamp: 'timestamp',
		stateCode: 'state-code'
	};
	static readonly MarketDepthBestPriceSchema = {
		time: 'timestamp',
		buyVolume1: 'buy-volume-1',
		sellVolume1: 'sell-volume-1',
		buyOrderCount1: 'buy-order-count-1',
		sellOrderCount1: 'sell-order-count-1',
		buyPrice1: 'buy-price-1',
		sellPrice1: 'sell-price-1',
		buyVolume2: 'buy-volume-2',
		sellVolume2: 'sell-volume-2',
		buyOrderCount2: 'buy-order-count-2',
		sellOrderCount2: 'sell-order-count-2',
		buyPrice2: 'buy-price-2',
		sellPrice2: 'sell-price-2',
		buyVolume3: 'buy-volume-3',
		sellVolume3: 'sell-volume-3',
		buyOrderCount3: 'buy-order-count-3',
		sellOrderCount3: 'sell-order-count-3',
		buyPrice3: 'buy-price-3',
		sellPrice3: 'sell-price-3',
		buyVolume4: 'buy-volume-4',
		sellVolume4: 'sell-volume-4',
		buyOrderCount4: 'buy-order-count-4',
		sellOrderCount4: 'sell-order-count-4',
		buyPrice4: 'buy-price-4',
		sellPrice4: 'sell-price-4',
		buyVolume5: 'buy-volume-5',
		sellVolume5: 'sell-volume-5',
		buyOrderCount5: 'buy-order-count-5',
		sellOrderCount5: 'sell-order-count-5',
		buyPrice5: 'buy-price-5',
		sellPrice5: 'sell-price-5'
	};
	static readonly MoneySchema = {
		timestamp: 'timestamp',
		meta: 'meta'
	};
	static readonly orderStateNewSchema = {
		timestamp: 'timestamp',
		meta: 'meta'
	};
	static readonly orderPlaceSchema = {
		isin: 'isin',
		volumeAhead: 'volume-ahead',
		placement: 'placement'
	};
	static readonly SymbolSchema = {
		totalNumberOfSharesTraded: 'total-number-of-shares-traded',
		totalNumberOfTrades: 'total-number-of-trades',
		totalTradeValue: 'total-trade-value',
		closingPrice: 'closing-price',
		firstPrice: 'opening-price',
		lastTradedPrice: 'last-trade-price',
		maxDailyPrice: 'max-daily-price',
		minDailyPrice: 'min-daily-price',
		bestBuyLimitVolume: 'buy-volume-1',
		bestBuyLimitPrice: 'buy-price-1',
		bestSellLimitPrice: 'sell-price-1',
		bestSellLimitVolume: 'sell-volume-1',
		stateCode: 'state-code',
		minValidBuyVolume: 'min-valid-buy-volume',
		minValidSellVolume: 'min-valid-sell-volume',
		maxValidBuyVolume: 'max-valid-buy-volume',
		maxValidSellVolume: 'max-valid-sell-volume',
		feeOfPreviousDaysClosingPrice: 'prev-closing-price',
		maxDailyTradedPrice: 'max-daily-traded-price',
		minDailyTradedPrice: 'min-daily-traded-price',
		priceTickSize: 'min-dealable-price',
		tradeDate: 'trade-date2',
		lastTradedPriceVarPercent: 'price-variation',
		navDate: 'nav-date',
		navSubscription: 'nav-subscription',
		navRedemption: 'nav-redemption'
	};

	static readonly ActiveStockSchema = {
		firstTradedPrice: this.SymbolSchema.firstPrice,
		totalNumberOfTrades: this.SymbolSchema.totalNumberOfTrades,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		closePrice: this.SymbolSchema.closingPrice,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		stateCode: this.SymbolSchema.stateCode,
		tradeDate: this.SymbolSchema.tradeDate,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		navDate: this.SymbolSchema.navDate,
		navSubscription: this.SymbolSchema.navSubscription,
		navRedemption: this.SymbolSchema.navRedemption,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent,
		maxDailyTradedPrice: this.SymbolSchema.maxDailyTradedPrice,
		minDailyTradedPrice: this.SymbolSchema.minDailyTradedPrice,
		priceTickSize: this.SymbolSchema.priceTickSize,
		minValidBuyVolume: this.SymbolSchema.minValidBuyVolume,
		minValidSellVolume: this.SymbolSchema.minValidSellVolume,
		maxValidBuyVolume: this.SymbolSchema.maxValidBuyVolume,
		maxValidSellVolume: this.SymbolSchema.maxValidSellVolume,
		bidPrice: this.SymbolSchema.bestSellLimitPrice,
		askPrice: this.SymbolSchema.bestBuyLimitPrice
	};

	static readonly SameGroupSchema = {
		closePrice: this.SymbolSchema.closingPrice,
		firstTradedPrice: this.SymbolSchema.firstPrice,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		maxDailyTradedPrice: this.SymbolSchema.maxDailyTradedPrice,
		minDailyTradedPrice: this.SymbolSchema.minDailyTradedPrice,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		stateCode: this.SymbolSchema.stateCode,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		bidPrice: this.SymbolSchema.bestSellLimitPrice,
		askPrice: this.SymbolSchema.bestBuyLimitPrice
	};

	static readonly TradeVolumeSchema = {
		isin: 'isin',
		timestamp: 'timestamp',
		institutionCode: 'institution-code',
		buyCountPerson: 'buy-count-person',
		buyCountLegal: 'buy-count-legal',
		buyVolumePerson: 'buy-volume-person',
		buyVolumeLegal: 'buy-volume-legal',
		sellCountPerson: 'sell-count-person',
		sellCountLegal: 'sell-count-legal',
		sellVolumePerson: 'sell-volume-person',
		sellVolumeLegal: 'sell-volume-legal'
	};

	static readonly SymbolHeaderSchema = {
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		closePrice: this.SymbolSchema.closingPrice,
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		stateCode: this.SymbolSchema.stateCode,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent
	};

	static readonly MarketDepthSymbolSchema = {
		maxDailyTradedPrice: this.SymbolSchema.maxDailyTradedPrice,
		minDailyTradedPrice: this.SymbolSchema.minDailyTradedPrice,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		closePrice: this.SymbolSchema.closingPrice,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		firstPrice: this.SymbolSchema.firstPrice,
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded
	};

	static readonly StockInfoSchema = {
		firstPrice: this.SymbolSchema.firstPrice,
		totalNumberOfTrades: this.SymbolSchema.totalNumberOfTrades,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		closePrice: this.SymbolSchema.closingPrice,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		stateCode: this.SymbolSchema.stateCode,
		tradeDate: this.SymbolSchema.tradeDate,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		navDate: this.SymbolSchema.navDate,
		navSubscription: this.SymbolSchema.navSubscription,
		navRedemption: this.SymbolSchema.navRedemption
	};

	static readonly DPortfolioSchema = {
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		totalNumberOfTrades: this.SymbolSchema.totalNumberOfTrades,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		closingPrice: this.SymbolSchema.closingPrice,
		firstTradedPrice: this.SymbolSchema.firstPrice,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		minDailyTradedPrice: this.SymbolSchema.minDailyTradedPrice,
		maxDailyTradedPrice: this.SymbolSchema.maxDailyTradedPrice,
		bestBuyLimitVolume: this.SymbolSchema.bestBuyLimitVolume,
		bestBuyLimitPrice: this.SymbolSchema.bestBuyLimitPrice,
		bestSellLimitPrice: this.SymbolSchema.bestSellLimitPrice,
		bestSellLimitVolume: this.SymbolSchema.bestSellLimitVolume,
		stateCode: this.SymbolSchema.stateCode,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent,
		tradeDate: this.SymbolSchema.tradeDate
	};
	static readonly DRealtimePortfolioSchema = {
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		totalNumberOfTrades: this.SymbolSchema.totalNumberOfTrades,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		closePrice: this.SymbolSchema.closingPrice,
		firstPrice: this.SymbolSchema.firstPrice,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		bestBuyLimitVolume: this.SymbolSchema.bestBuyLimitVolume,
		bestBuyLimitPrice: this.SymbolSchema.bestBuyLimitPrice,
		bestSellLimitPrice: this.SymbolSchema.bestSellLimitPrice,
		bestSellLimitVolume: this.SymbolSchema.bestSellLimitVolume,
		stateCode: this.SymbolSchema.stateCode,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent,
		tradeDate: this.SymbolSchema.tradeDate
	};
	static readonly MarketWatchSchema = {
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		totalNumberOfTrades: this.SymbolSchema.totalNumberOfTrades,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		closingPrice: this.SymbolSchema.closingPrice,
		firstTradedPrice: this.SymbolSchema.firstPrice,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		bestBuyLimitVolume: this.SymbolSchema.bestBuyLimitVolume,
		bestBuyLimitPrice: this.SymbolSchema.bestBuyLimitPrice,
		bestSellLimitPrice: this.SymbolSchema.bestSellLimitPrice,
		bestSellLimitVolume: this.SymbolSchema.bestSellLimitVolume,
		stateCode: this.SymbolSchema.stateCode,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent,
		///
		maxDailyTradedPrice: this.SymbolSchema.maxDailyTradedPrice,
		minDailyTradedPrice: this.SymbolSchema.minDailyTradedPrice
	};
	static readonly MobileWatchSchema = {
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		totalNumberOfTrades: this.SymbolSchema.totalNumberOfTrades,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		firstTradedPrice: this.SymbolSchema.firstPrice,
		closingPrice: this.SymbolSchema.closingPrice,
		stateCode: this.SymbolSchema.stateCode,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		bestBuyLimitPrice: this.SymbolSchema.bestBuyLimitPrice,
		bestSellLimitPrice: this.SymbolSchema.bestSellLimitPrice,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		maxDailyTradedPrice: this.SymbolSchema.maxDailyTradedPrice,
		minDailyTradedPrice: this.SymbolSchema.minDailyTradedPrice
	};
	static readonly MobilePortfolioSchema = {
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		closingPrice: this.SymbolSchema.closingPrice,
		stateCode: this.SymbolSchema.stateCode,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent
	};
	static readonly MobileRealTimePortfolioSchema = {
		LastTradedPrice: this.SymbolSchema.lastTradedPrice,
		ClosingPrice: this.SymbolSchema.closingPrice,
		stateCode: this.SymbolSchema.stateCode,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		TotalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent
	};
	static readonly OrderFormSchema = {
		priceTickSize: this.SymbolSchema.priceTickSize,
		minValidBuyVolume: this.SymbolSchema.minValidBuyVolume,
		minValidSellVolume: this.SymbolSchema.minValidSellVolume,
		maxValidBuyVolume: this.SymbolSchema.maxValidBuyVolume,
		maxValidSellVolume: this.SymbolSchema.maxValidSellVolume,
		maxDailyPrice: this.SymbolSchema.maxDailyPrice,
		minDailyPrice: this.SymbolSchema.minDailyPrice,
		bidPrice: this.SymbolSchema.bestSellLimitPrice,
		askPrice: this.SymbolSchema.bestBuyLimitPrice,
		feeOfPreviousDaysClosingPrice: this.SymbolHeaderSchema.feeOfPreviousDaysClosingPrice
	};
	static readonly OrderFormAskOrBidSchema = {
		bidPrice: this.SymbolSchema.bestSellLimitPrice,
		askPrice: this.SymbolSchema.bestBuyLimitPrice
	};
	static readonly EasyFilterSchema = {
		ClosingPrice: this.SymbolSchema.closingPrice,
		LastTradedPrice: this.SymbolSchema.lastTradedPrice,
		TotalTradeValue: this.SymbolSchema.totalTradeValue,
		TotalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		BestBuyLimitPrice_1: this.SymbolSchema.bestBuyLimitPrice,
		BestSellLimitPrice_1: this.SymbolSchema.bestSellLimitPrice,
		BestBuyLimitQuantity_1: this.SymbolSchema.bestBuyLimitVolume,
		BestSellLimitQuantity_1: this.SymbolSchema.bestSellLimitVolume,
		SymbolStateId: this.SymbolSchema.stateCode,
		LowAllowedPrice: this.SymbolSchema.minDailyPrice,
		HighAllowedPrice: this.SymbolSchema.maxDailyPrice,
		LowPrice: this.SymbolSchema.minDailyTradedPrice,
		HighPrice: this.SymbolSchema.maxDailyTradedPrice,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent
	};
	static readonly EasyFilterIndInstSchema = {
		IndInstTrade_Individual_SellVolume: this.TradeVolumeSchema.sellVolumePerson,
		IndInstTrade_Individual_BuyVolume: this.TradeVolumeSchema.buyVolumePerson,
		IndInstTrade_Institutional_SellVolume: this.TradeVolumeSchema.sellVolumeLegal,
		IndInstTrade_Institutional_BuyVolume: this.TradeVolumeSchema.buyVolumeLegal
	};
	static readonly SearchSchema = {
		SymbolStateId: this.SymbolSchema.stateCode,
		LastTradedPrice: this.SymbolSchema.lastTradedPrice,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		TotalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent
	};

	static readonly RecentSearchSchema = {
		SymbolStateId: this.SymbolSchema.stateCode,
		LastTradedPrice: this.SymbolSchema.lastTradedPrice,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		TotalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent,
		closePrice: this.SymbolSchema.closingPrice
	};

	static readonly ConditionalSchema = {
		LastTradedPrice: this.SymbolSchema.lastTradedPrice,
		TotalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		BestBuyLimitQuantity_1: this.SymbolSchema.bestBuyLimitVolume,
		BestSellLimitQuantity_1: this.SymbolSchema.bestSellLimitVolume,
		ClosingPrice: this.SymbolSchema.closingPrice,
		BestBuyLimitPrice_1: this.SymbolSchema.bestBuyLimitPrice,
		BestSellLimitPrice_1: this.SymbolSchema.bestSellLimitPrice,
		TotalTradeValue: this.SymbolSchema.totalTradeValue,
		FeeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent
	};

	static readonly MarketAffectingSchema = {
		SymbolStateId: this.SymbolSchema.stateCode,
		LastTradedPrice: this.SymbolSchema.lastTradedPrice,
		FeeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		TotalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent
	};

	static readonly BestOfMarketSchema = {
		SymbolStateId: this.SymbolSchema.stateCode,
		LastTradedPrice: this.SymbolSchema.lastTradedPrice,
		lastTradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent,
		BestBuyLimitPrice_1: this.SymbolSchema.bestBuyLimitPrice,
		BestSellLimitPrice_1: this.SymbolSchema.bestSellLimitPrice,
		BestSellLimitQuantity_1: this.SymbolSchema.bestSellLimitVolume,
		BestBuyLimitQuantity_1: this.SymbolSchema.bestBuyLimitVolume
	};
	static readonly MarketViewTopRankSchema = {
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		totalNumberOfTrades: this.SymbolSchema.totalNumberOfTrades,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		tradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent,
		stateCode: this.SymbolSchema.stateCode,
		closePrice: this.SymbolSchema.closingPrice,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		bestBuyLimitVolume: this.SymbolSchema.bestBuyLimitVolume,
		bestSellLimitVolume: this.SymbolSchema.bestSellLimitVolume
	};

	static readonly TodayActivity = {
		SymbolStateId: this.SymbolSchema.stateCode
	};
	static readonly OptionMarketViewSchema = {
		stateCode: this.SymbolSchema.stateCode,
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		lastTradedPriceVarPercent: this.SymbolSchema.lastTradedPriceVarPercent,
		closingPrice: this.SymbolSchema.closingPrice,
		totalNumberOfSharesTraded: this.SymbolSchema.totalNumberOfSharesTraded,
		totalTradeValue: this.SymbolSchema.totalTradeValue,
		feeOfPreviousDaysClosingPrice: this.SymbolSchema.feeOfPreviousDaysClosingPrice,
		bestBuyLimitVolume: this.SymbolSchema.bestBuyLimitVolume,
		bestBuyLimitPrice: this.SymbolSchema.bestBuyLimitPrice,
		bestSellLimitPrice: this.SymbolSchema.bestSellLimitPrice,
		bestSellLimitVolume: this.SymbolSchema.bestSellLimitVolume
	};
	static readonly BlackScholesCalculatorSchema = {
		lastTradedPrice: this.SymbolSchema.lastTradedPrice
	};

	static readonly ContractInfoSchema = {
		lastTradedPrice: this.SymbolSchema.lastTradedPrice,
		tradedPriceVar: this.SymbolSchema.lastTradedPriceVarPercent
	};

	static readonly MarketSheetSchema = {
		BuyCount: 'buy-count',
		SellCount: 'sell-count',
		BuyVolume: 'buy-volume',
		SellVolume: 'sell-volume'
	};
	static readonly MarketSheetBuyChartSchema = {
		meta: 'meta'
	};

	static readonly MarketSheetSellChartSchema = {
		meta: 'meta'
	};
	static readonly PerformanceSchema = {
		meta: 'meta'
	};
	static readonly PerformanceDetailSchema = {
		meta: 'meta'
	};
	static readonly AlgoParentSchema = {
		meta: 'meta'
	};
	static readonly PerformanceRecalculateSchema = {
		meta: 'meta'
	};
	static readonly MtsCommandSchema = {
		meta: 'meta'
	};
	static readonly OptionPositionSchema = {
		meta: 'meta'
	};
	static readonly OptionContractSchema = {
		initialMargin: 'initial-margin',
		requiredMargin: 'required-margin',
		maintenanceMargin: 'maintenance-margin',
		openPositions: 'open-positions'
	};
	static readonly OptionCustomerStatusSchema = {
		meta: 'meta'
	};
}
